import { TicketDockDto } from "mock-api/src/shared-v2-types";
import { getApiDetailsDecorator } from "src/utils";

const api = getApiDetailsDecorator<TicketDockDto>();

export class HelpAssistTicketDock {
  private constructor(args: ClassProperties<HelpAssistTicketDock>) {
    this.id = args.id;
    this.name = args.name;
  }

  @api() public readonly id: number;
  @api() public readonly name: string;

  public static deserialize(apiModel: TicketDockDto): HelpAssistTicketDock {
    return new HelpAssistTicketDock({
      id: apiModel.id,
      name: apiModel.name,
    });
  }
}
